import { Alert, Box } from '@mui/material';

/**
 * The workbook Instructions sheet's "useful hints", shown contextually —
 * only the ones triggered by the current test selection.
 */
export const AdvisoryHints = ({ hints }: { hints: string[] }) => {
  if (hints.length === 0) return null;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
      {hints.map((hint) => (
        <Alert key={hint} severity="info" sx={{ py: 0.25 }}>{hint}</Alert>
      ))}
    </Box>
  );
};
